import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:manageOrganizationList
 * @description
 * # manageOrganizationList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('manageOrganizationSubmissionList', ($ngRedux, $scope, $rootScope, $location, $route) => {
    if (!$scope.isAdminUser) {
      $location.path('/');
    }

    $scope.takeAction = (id) => {
      $scope.onOrganizationSubmissionProcessing({ submissionId: id });
    };

    $scope.generatebeforeRoute = (id) => {
      return `${$rootScope.routes['organizationsubmissions']}/transaction-detail/${id}`;
    };

    $scope.generatecloseRoute = () => {
      return `${$rootScope.routes['organizationsubmissions']}`;
    };

    $scope.processParams = () =>
      new Promise((resolve) => {
        const { organizationId } = $route.current.params;
        $scope.takeAction(organizationId);
        resolve(true);
      });

    $scope.init = () => {
      $rootScope.previousRoute = $rootScope.routes.organization;
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.processParams();
    };

    $scope.table = {
      name: 'Manage Organization Submissions',
      options: {
        endpoint: '/2.0/organizations/submissions/',
        endpoint_data_key: 'organization-submissions',
        per_page_options: [15, 25, 50, 100, 200],
        records_per_page: 15,
        row_style: 'standard',
        scale_up: true,
        search_key: null,
        search_required: false,
      },
      actions: [],
      columns: [
        {
          name: 'Date Submitted',
          options: {
            content: '{{ record.created }}',
            class: '',
          },
        },
        {
          name: "Submitted By",
          options: {
            content:
              '<a ng-if="record.created_by.first_name || record.created_by.last_name" href="#" ng-href="/admin/users/manage-users/{{ record.created_by.id }}">' +
              '{{ record.created_by.first_name }} {{ record.created_by.last_name }}' +
              '</a>' +
              '<br ng-if="record.created_by.contact_information.email && (record.created_by.first_name || record.created_by.last_name)" />' +
              '<a ng-class="{\'small email\': (record.created_by.first_name || record.created_by.last_name)}" ng-if="record.created_by.contact_information.email" href="#" ng-href="/admin/users/manage-users/{{ record.created_by.id }}">' +
              '{{ record.created_by.contact_information.email }}' +
              '</a>',
            class: 'td-user',
          },
        },
        {
          name: 'Organization Name',
          options: {
            content: '{{ record.name }}',
            class: '',
          },
        },
        {
          name: 'Location Information',
          options: {
            content:
              '<span ng-if="record.city">{{ record.city }}, </span><span ng-if="record.state">{{ record.state }} </span>' +
              '<span ng-if="record.zipcode">{{ record.zipcode }}</span>',
            class: '',
          },
        },
        {
          name: 'Transactions(s)',
          options: {
            content:
              '<ul><li ng-repeat="transaction in record.transactions"><a href="#" ng-click="showTransactionDetail({transactionId: transaction.id, beforeRoute: generatebeforeRoute(transaction.id), closeRoute: generatecloseRoute()})">Transaction ID: {{ transaction.id }}</a></li></ul>',
            class: 'list-column',
          },
        },
        {
          name: 'Action',
          options: {
            content:
              '<a href="#" ng-if="!record.organization" ng-click="onOrganizationSubmissionProcessing({ submissionId: record.id });">Find or Create Organization</a>',
            class: 'td-action',
          },
        },
      ],
      filters: [
        {
          name: 'Moderation Status',
          type: 'multiple_choice',
          options: {
            choices: {
              'Not Moderated': { type: 'standard', state: true, value: 'false', order: 0 },
              Moderated: { type: 'standard', state: false, value: 'true', order: 1 },
            },
            class: '',
            name_attribute: 'name',
            query_string_parameter: 'moderated',
            select_all: false,
          },
        },
        {
          name: 'Timeframe',
          type: 'single_choice',
          options: {
            choices: {
              'Last 24 Hours': { type: 'standard', state: true, value: 'day', order: 0 },
              'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
              'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
              All: { type: 'standard', state: false, value: 'all', order: 3 },
              'Custom Range': {
                type: 'range',
                state: false,
                value: 'range',
                from: '',
                to: '',
                date_field: true,
                order: 4,
                error: false,
              },
            },
            class: 'timeframe-filter',
            query_string_parameter: 'timeframe',
          },
        },
      ],
      sort_options: {
        created: {
          state: false,
          value: '-1',
          title: 'Date Submitted',
          order: 0,
        },
        updated: {
          state: true,
          value: '-1',
          title: 'Date Updated',
          order: 1,
        },
      },
    };

    $scope.$on('$routeChangeStart', async (event, current) => {
      if (!current?.params?.transactionId) {
        $rootScope.userId = null;
      }
    });

    $scope.init();

    $scope.$on('$destroy', $scope.unsubscribe);
  });
